import { useEffect, useState } from "react";
import { motion } from "framer-motion";
import { Logo } from "../components/Logo";
import { useAuth } from "../context/AuthContext";
import { CheckCircle2, Loader2 } from "lucide-react";

// Pantalla de agradecimiento tras el pago (enlaces de Stripe redirigen aquí).
// Muestra el mensaje, refresca la sesión para tomar la reactivación del webhook
// y redirige automáticamente al panel.
export default function PaymentReturn() {
  const { checkAuth } = useAuth();
  const [secs, setSecs] = useState(6);

  useEffect(() => {
    // Reintenta refrescar la sesión mientras el webhook reactiva la licencia.
    let tries = 0;
    const iv = setInterval(async () => {
      tries += 1;
      try { await checkAuth(); } catch (e) { /* noop */ }
      if (tries >= 3) clearInterval(iv);
    }, 1500);
    return () => clearInterval(iv);
  }, [checkAuth]);

  useEffect(() => {
    const tick = setInterval(() => setSecs((s) => (s > 0 ? s - 1 : 0)), 1000);
    const go = setTimeout(() => { window.location.replace("/dashboard"); }, 6000);
    return () => { clearInterval(tick); clearTimeout(go); };
  }, []);

  return (
    <div className="min-h-screen flex items-center justify-center p-5"
      style={{ background: "radial-gradient(1000px 500px at 50% -10%, rgba(37,99,174,.12), transparent 60%), #0b1220" }}
      data-testid="payment-return">
      <motion.div initial={{ opacity: 0, y: 20, scale: 0.98 }} animate={{ opacity: 1, y: 0, scale: 1 }} transition={{ duration: 0.5 }}
        className="w-full max-w-md bg-white rounded-3xl shadow-2xl p-9 text-center">
        <div className="flex justify-center mb-6"><Logo size={42} /></div>
        <motion.div initial={{ scale: 0 }} animate={{ scale: 1 }} transition={{ delay: 0.2, type: "spring", stiffness: 200 }}
          className="w-20 h-20 rounded-full mx-auto grid place-items-center mb-5"
          style={{ background: "linear-gradient(135deg,#2563AE,#1e88a8)" }}>
          <CheckCircle2 className="text-white" size={44} data-testid="payment-success" />
        </motion.div>
        <h1 className="font-outfit font-extrabold text-2xl text-brand-ink tracking-tight">¡Gracias por confiar en ClinPed!</h1>
        <p className="text-brand-ink/70 mt-3 leading-relaxed">
          Tu pago fue <b>procesado correctamente</b>. En unos segundos te llevaremos a tu panel de control…
        </p>
        <div className="mt-6 flex items-center justify-center gap-2 text-sm font-semibold" style={{ color: "#2563AE" }}>
          <Loader2 className="animate-spin" size={16} /> Redirigiendo a tu sesión ({secs})
        </div>
        <button data-testid="payment-go-now" onClick={() => window.location.replace("/dashboard")}
          className="mt-6 w-full text-white font-outfit font-semibold py-3 rounded-2xl transition-all hover:brightness-110"
          style={{ background: "#0b1220" }}>
          Ir a mi panel ahora
        </button>
      </motion.div>
    </div>
  );
}
